import { render, staticRenderFns } from "./EditBread.vue?vue&type=template&id=5b618fa4&"
import script from "./EditBread.vue?vue&type=script&lang=js&"
export * from "./EditBread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports